import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useApi';

interface DeveloperRouteProps {
  children?: React.ReactNode;
}

export const DeveloperRoute: React.FC<DeveloperRouteProps> = ({ children }) => {
  const { data: user } = useCurrentUser();
  
  if (!user?.permissions?.includes('developer_tools.view')) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children || <Outlet />}</>;
};